import type { Action } from 'redux'
import { payloadAsParam } from '../../../signalr/helpers'
import type { InvokeDefinition } from '../../../signalr/types'
import { addManagementReport, managementReportFetchFail } from './actions'
import type { ManagementReport } from './types'

export const fetchManagementReportDefinition: InvokeDefinition<
  [Date],
  ManagementReport,
  Action
> = {
  method: 'GetManagementReports',
  strategy: 'switch',
  getParams: payloadAsParam,
  mapResponse: addManagementReport,
  mapError: managementReportFetchFail
}
